import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api, errMsg } from "../lib/api";
import { useT } from "../lib/i18n";
import { Field, NativeSelect } from "./Common";

const METHODS = ["cash", "card", "bank_transfer", "sumup", "other"];
const TYPES = ["balance", "deposit", "package", "product", "other"];

export default function PaymentDialog({ open, onOpenChange, clientId, locationId, appointment, defaultAmount, currency, onSaved }) {
  const { t } = useT();
  const [f, setF] = useState({ amount: "", method: "card", type: "balance", note: "" });

  useEffect(() => {
    if (open) setF({ amount: defaultAmount > 0 ? defaultAmount.toFixed(2) : "", method: "card", type: "balance", note: "" });
  }, [open, defaultAmount]);

  const save = async () => {
    try {
      await api.post("/payments", { ...f, amount: parseFloat(f.amount), client_id: clientId, location_id: locationId, appointment_id: appointment?.id });
      toast.success("Payment recorded");
      onOpenChange(false);
      onSaved?.();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="payment-dialog">
        <DialogHeader><DialogTitle>{t("take_payment")} {currency && <span className="text-muted-foreground text-sm">({currency})</span>}</DialogTitle></DialogHeader>
        <div className="grid gap-4">
          <Field label={t("amount")}>
            <Input data-testid="payment-amount-input" type="number" step="0.01" min="0" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} />
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label={t("method")}>
              <NativeSelect testId="payment-method-select" value={f.method} onChange={(v) => setF({ ...f, method: v })} options={METHODS.map((m) => ({ value: m, label: m.replace("_", " ") }))} />
            </Field>
            <Field label={t("type")}>
              <NativeSelect testId="payment-type-select" value={f.type} onChange={(v) => setF({ ...f, type: v })} options={TYPES.map((m) => ({ value: m, label: m }))} />
            </Field>
          </div>
          <Field label={t("notes")}><Input data-testid="payment-note-input" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} /></Field>
          <Button data-testid="payment-save-button" className="rounded-full" disabled={!(parseFloat(f.amount) > 0)} onClick={save}>{t("save")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
